<template>
  <div class="right-chart-1">
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="grid-content">检查部位：{{ params.hxcs_position }}</div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content">设备台数：{{ partData.equipmentCount }}</div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content">检查次数：{{ partData.inspecteCount }}</div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content" ref="moneyCount">
          检查收益（万元）：
          <el-tooltip
            :content="partData.moneyCount"
            placement="left"
            v-if="showTooltip"
          >
            <span>{{ (partData.moneyCount / 10000).toFixed(2) || 0 }}</span>
          </el-tooltip>
          <span v-else>{{ (partData.moneyCount / 10000).toFixed(2) || 0 }}</span>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="grid-content">
          检查有效时长（小时）：{{ partData.effectiveCount }}
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { textRange } from '@/utils/index'
import { selectInspectTypeMr } from '@/api/modules/dataView.js'
export default {
  name: 'RightChart1',
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
          hxcs_position: '',
        }
      },
    },
  },
  data() {
    return {
      showTooltip: false,
      partData: {
        equipmentCount: 0,
        inspecteCount: 0,
        effectiveCount: 0,
        moneyCount: 0,
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      selectInspectTypeMr(this.params).then(data => {
        this.partData = data
        this.$nextTick(() => {
          this.showTooltip = textRange(this.$refs.moneyCount)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.right-chart-1 {
  width: 100%;
  height: 14%;
  display: flex;
  flex-direction: column;
  border: 2px solid rgba(97, 218, 248, 0.6);
  background-color: rgba(43, 150, 177, 0.6);
  .grid-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 6px 10px;
  }
}
</style>
